import {apiV2} from 'api/v2/mutator';
import type {InviteDetails, RegisterPayload, RegisterResponse} from './types';

// These are PUBLIC, unauthenticated endpoints. They reuse the shared V2 axios
// instance (configured in App.js); when there is no logged-in session no
// Authorization header is attached. Responses are already camelCase.

export const getInvite = async (token: string): Promise<InviteDetails> => {
  const {data} = await apiV2<InviteDetails>({
    url: `/auth/invites/${encodeURIComponent(token)}/`,
    method: 'GET',
  });
  return data;
};

export const registerInvite = async (
  token: string,
  payload: RegisterPayload,
): Promise<RegisterResponse> => {
  const {data} = await apiV2<RegisterResponse>({
    url: `/auth/invites/${encodeURIComponent(token)}/register/`,
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    data: payload,
  });
  return data;
};
